module.exports = __webpack_public_path__ + "img/mm.f608e3e1.png";